import React, { useEffect } from 'react';
import { Mail } from 'lucide-react';

export const Contact = () => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-purple-25 py-12 px-6 lg:px-12">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-heading font-light mb-4">Contact Us</h1>
          <p className="text-lg text-stone-600">
            We're here to help! Reach out to us with any questions or concerns.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Contact Information */}
          <div className="bg-white rounded-2xl p-8">
            <h2 className="text-2xl font-heading font-light mb-6">Get in Touch</h2>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                  <Mail className="h-6 w-6 text-purple-600" />
                </div>
                <div>
                  <h3 className="font-medium mb-1">Email</h3>
                  <a 
                    href="mailto:healermarah@gmail.com" 
                    className="text-purple-600 hover:text-purple-700"
                  >
                    healermarah@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="bg-white rounded-2xl p-8">
            <h2 className="text-2xl font-heading font-light mb-6">Quick Answers</h2>
            
            <div className="space-y-4">
              <div>
                <h3 className="font-medium mb-2">What is SAC® technology?</h3>
                <p className="text-sm text-stone-600">
                  SAC® is our revolutionary calcium ion delivery system derived from oyster shells, 
                  designed for optimal cellular absorption and natural healing.
                </p>
              </div>

              <div>
                <h3 className="font-medium mb-2">Are your products safe?</h3>
                <p className="text-sm text-stone-600">
                  Absolutely. All our products are manufactured using our proprietary SAC® technology 
                  that eliminates heavy metals, toxins, and impurities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
